import React from "react";
import styled from "styled-components";
import { Card, Statistic, Typography, Space } from "antd";
import { ArrowUpOutlined, ArrowDownOutlined, MinusOutlined } from "@ant-design/icons";

const { Text } = Typography;

const StyledCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .ant-card-body {
    padding: 24px;
  }
`;

const TrendIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  font-size: 12px;
`;

const TrendValue = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  
  &.trend-up {
    color: #52c41a;
  }
  
  &.trend-down {
    color: #ff4d4f;
  }
  
  &.trend-neutral {
    color: #8c8c8c;
  }
`;

const EnhancedStatsCard = ({
  title,
  value,
  prefix,
  valueStyle,
  trendYesterday,
  trendLastWeek,
  priority = "normal", // "high" | "normal" | "low"
}) => {
  const formatTrend = (trend) => {
    if (trend === null || trend === undefined || trend === 0) return null;
    
    const isPositive = trend > 0;
    const absValue = Math.abs(trend);
    const Icon = isPositive ? ArrowUpOutlined : ArrowDownOutlined;
    const className = isPositive ? "trend-up" : "trend-down";
    
    return (
      <TrendValue className={className}>
        <Icon style={{ fontSize: 10 }} />
        {absValue}
      </TrendValue>
    );
  };

  return (
    <StyledCard>
      <Statistic
        title={title}
        value={value}
        prefix={prefix}
        valueStyle={{
          ...valueStyle,
          fontSize: priority === "high" ? "32px" : "28px",
          fontWeight: priority === "high" ? 700 : 600,
        }}
      />
      <TrendIndicator>
        {trendYesterday !== null && trendYesterday !== undefined && (
          <>
            {formatTrend(trendYesterday) || (
              <TrendValue className="trend-neutral">
                <MinusOutlined style={{ fontSize: 10 }} />
                0
              </TrendValue>
            )}
            <Text type="secondary" style={{ fontSize: 11 }}>
              vs yesterday
            </Text>
          </>
        )}
        {trendLastWeek !== null && trendLastWeek !== undefined && (
          <>
            <Text type="secondary" style={{ marginLeft: 8, fontSize: 11 }}>
              ·
            </Text>
            {formatTrend(trendLastWeek) || (
              <TrendValue className="trend-neutral">
                <MinusOutlined style={{ fontSize: 10 }} />
                0
              </TrendValue>
            )}
            <Text type="secondary" style={{ fontSize: 11 }}>
              vs 7d
            </Text>
          </>
        )}
      </TrendIndicator>
    </StyledCard>
  );
};

export default EnhancedStatsCard;

